import styled from 'styled-components';

export const StyleVerticalBar = styled.div`
    &::after {
        border-left: solid 1px var(--color-gray-light);
        content: ' ';
        height: 100%;
        display: inline-block;
    }
`;
